const contentful = require("contentful");

export default contentful.createClient({
  space: "cpgwrr1s4y9o",
  accessToken: "CFPAT-KCbKuGJGqRHt37QHGAfqa-UfVHTS5qyeNU2qtaGxPOA"
});
